// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__3McVy","btn":"NotFound_btn__aM3s9"};